import { stringify } from 'yaml';
import { WorkerAction, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';
import { FSWriteFileActionFn } from './fs-write-file';

export interface FSWriteYAMLAction extends WorkerAction {
  type: FSAction.WriteYAML;
  params: {
    path: string;
    propertyPath?: string[];
    content?: unknown;
    skipSync?: boolean;
  };
}

export async function FSWriteYAMLActionFn(params: WorkerFnParams<FSWriteYAMLAction>): Promise<void> {
  const { params: actionParams, ...workerFnParams } = params;
  await FSWriteFileActionFn({
    ...workerFnParams,
    params: {
      ...actionParams,
      content: stringifyYAML(actionParams.content || ''),
    },
  });
}

/**
 * Define a common method that all feature services will use
 * to stringify the models before writing to git.
 */
export function stringifyYAML(value: unknown) {
  return stringify(value);
}
